<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <h2>Add Supporting Document</h2>
    </div>
    <div class="modal-card-body">
      <div>
        <div>
          <b-input placeholder="Title" type="text" v-model="Title"></b-input>
          <br />
          <b-upload accept=".pdf,.doc,.docx" v-model="File">
            <a class="button is-primary" icon="fad fa-upload">Upload Document</a>
            <span style="margin-left: 7px;margin-top:5px;" class="has-text-weight-bold" v-if="File">
              {{ File.name }}
            </span>
          </b-upload>
          <div style="font-size:0.7em">
            <span>Accepts .pdf and .doc(x)</span>
          </div>
          <br />
          <h3>Document Access</h3>
          <div class="breathe-md">
            <b-radio v-model="Access" native-value="Global">Global</b-radio>
          </div>
          <div class="breathe-md">
            <b-radio v-model="Access" native-value="Member">Country Specific, AWG Charter Members, Paid Access</b-radio>
            <div style="padding-left:28px" v-show="Access == 'Member'">
              <b-select v-model="CountryId"
                        placeholder="Select Country">
                <option v-for="country in Countries"
                        :value="country.Id">
                  {{ country.Name }}
                </option>
              </b-select>
            </div>
          </div>
          <div class="breathe-md">
            <b-radio v-model="Access" native-value="Admin">Admin Only</b-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button @click="deleteFileAndClose">Cancel</b-button>
      <b-button class="is-primary" @click="addDocument">Add Document</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      Countries: Array
    },
    data() {
      return {
        Title: '',
        File: {},
        Access: '',
        CountryId: null
      }
    },
    methods: {
      addDocument() {
        if (this.Access && this.File && this.Title) {
          if (this.Access != "Member") {
            this.CountryId = null;
            this.$emit('addDocument', { File: this.File, CountryId: this.CountryId, Title: this.Title, Access: this.Access });
            this.$parent.close();
          }
          else {
            if (this.CountryId) {
              this.$emit('addDocument', { File: this.File, CountryId: this.CountryId, Title: this.Title, Access: this.Access });
              this.$parent.close();
            }
            else {
              this.$buefy.notification.open({
                duration: 4000,
                message: "Please fill out all fields",
                type: 'is-danger',
              })
            }
          }

        } else {
          this.$buefy.notification.open({
            duration: 4000,
            message: "Please fill out all fields",
            type: 'is-danger',
          })
        }
      },
      deleteFileAndClose() {
        if (this.File) {
          delete this.File;
        }
        this.$parent.close();
      }
    }
  }
</script>
